import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GiftPackagingTileModel } from '@/types/B2CcontentServerContract';
import { onUnmounted } from 'vue';
import useGiftPackaging from '@/shared/checkout/gift-packaging/useGiftPackaging';
import { ScopedBlockLabels, useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import GiftPackagingDialog from '@/shared/checkout/gift-packaging/ui/GiftPackagingDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPackagingTile',
  props: {
    content: null
  },
  setup(__props: any) {



const labels = useBlockLabels(ScopedBlockLabels.GiftPackagingTile);
const { register, unregister } = useGiftPackaging();

register(labels);
onUnmounted(unregister);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GiftPackagingDialog))
}
}

})